import { useMutation } from "react-query";
import { updateDriverUser } from "../../../api/accounts/driverUser";
import { notification } from "antd";

const useUpdateDriverUser = () => {
  const { mutateAsync, isLoading } = useMutation(updateDriverUser, {
    onError: (error) => {
      notification.error({
        message: "Update Driver User Failed",
        description: `${error}`,
      });
    },
  });

  return {
    updateDriverUser: mutateAsync,
    isLoading,
  };
};

export { useUpdateDriverUser };
